/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import 'moment/locale/pt';

import NewPolModal from "./components/newPolModal";

import FixedContainer from '../../components/Container';
import { Box, Button, Modal, Typography } from '@mui/material';
import LoadingComponent from '../../components/LoadingComponent';
import CustomizedTables from '../../components/Table';
import EditIcon from '@mui/icons-material/Edit';
import EditModal from './components/editModal';
import { enqueueSnackbar } from 'notistack';
import { GetFetch } from '../../services/apiBase';
import { ColumnsFocusReport, ColumnsRates } from './utils';
import { useLocation } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';

import axios from 'axios';
import RemoveModal from './components/removeModal';

const FinancialIndicators = () => {
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [openNewModal, setOpenNewModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openRemoveModal, setOpenRemoveModal] = useState(false);

  const [listTradeAgreement, setListTradeAgreement] = useState(null);
  const [tradeAgreementToEdit, setTradeAgreementToEdit] = useState({});

  const [tableValues, setTableValues] = useState([]);

  const [columnsTable, setColumnsTable] = useState([]);
  const [lastIpcaFactor, setLastIpcaFactor] = useState('');
  const [lastIpcaFactorToEdit, setLastIpcaFactorToEdit] = useState('');

  const table = location.state.table;

  const referenceTable = {
    CDI_FUTURO: 'CDI Futuro',
    IPCA_FUTURO: 'IPCA Futuro',
    REPORTS: 'Boletim Focus'
  }

  function filterAndSortByDateDesc(data, stringKey, stringValue, dateKey) {
    return data
      .filter(item => item[stringKey] === stringValue)
      .sort((a, b) => new Date(b[dateKey]) - new Date(a[dateKey]))
      .slice(0, 2);
  }

  const handleOpenEditModal = (indicator) => {
    if (indicator.name === 'IPCA') {
      indicator.type = 'ATUAL';
    }

    const [atualIpca, lastData] = filterAndSortByDateDesc(tableValues, 'name', 'IPCA', 'date_rate')
    setLastIpcaFactorToEdit(lastData.factor)
    setTradeAgreementToEdit(indicator);
    setOpenEditModal(true);
  }

  const handleOpenRemoveModal = (indicator) => {
    setTradeAgreementToEdit(indicator);
    setOpenRemoveModal(true);
  }

  const handleOpenNewModal = () => {
    setOpenNewModal(true);
  }

  const handleClose = () => {
    setOpenNewModal(false);
    setOpenEditModal(false);
    setOpenRemoveModal(false);
  }

  const fillTable = async () => {
    setLoading(true);
    setTableValues([]);
    try {
      //const response = await axios.get(`http://localhost:4600/financial/indicators?indicator=${table}`);
      const response = await GetFetch(`/financial/indicators?indicator=${table}`);

      if (response.data.error) {
        enqueueSnackbar(response.data.error, { variant: 'error' });
        return;
      }
      if (response.data.length === 0) {
        enqueueSnackbar('Não existem indicadores', { variant: 'error' });
        return;
      }
      setTableValues(response.data);
      setError(false);
    } catch (error) {
      console.log(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  const registerButtonComponent = (row) => {
    return (
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '50%',
            cursor: 'pointer'
          }}
          onClick={() => handleOpenRemoveModal(row)}
        >
          <DeleteIcon />
        </Box>
        {((row.id === findbiggestDateRateNamedIPCA(tableValues)) || (row.name === 'CDI_FUTURO') || (!row.name)) &&
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '50%',
              cursor: 'pointer'
            }}
            onClick={() => handleOpenEditModal(row)}
          >
            <EditIcon />
          </Box>
        }
      </Box>
    )
  }

  const TableComponent = () => {
    return (
      <Box>
        {tableValues && tableValues.length > 0
          ?
          <>
            <CustomizedTables
              data={tableValues}
              columns={columnsTable}
              moreOptionsTitle={'Apagar / Editar'}
              moreOptions={registerButtonComponent}
            />
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              Não foram encontradas indicadores
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os indicadores
        </Typography>
      </Box>
    )
  }

  function findbiggestDateRateNamedIPCA(tableValues) {
    let id = null;
    let biggestDateRate = new Date(0);
    let factor;
    for (const item of tableValues) {
      if (item.name === 'IPCA' || table === 'CDI_FUTURO') {
        const data = new Date(item.date_rate);
        if (data > biggestDateRate) {
          biggestDateRate = data;
          id = item.id;
          factor = item.factor;
        }
      }
    }
    setLastIpcaFactor(factor);
    return id;
  }

  useEffect(() => {
    fillTable();
    if (table === 'REPORTS') {
      setColumnsTable(ColumnsFocusReport);
    } else {
      setColumnsTable(ColumnsRates);
    }

    if (table === 'CDI_FUTURO') {

    }
  }, [columnsTable, table]);

  moment.locale('pt');
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Indicadores Financeiros / {`${referenceTable[table]}`}
          </Typography>

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: 1,
            marginTop: 1,
          }}>

            <Box>
              <Button variant="contained" color='success' sx={{ marginRight: 2 }} onClick={handleOpenNewModal}>Novo</Button>
            </Box>

          </Box>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
              listTradeAgreement && listTradeAgreement.length === 0 ?
                <Box sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'center'
                }}>
                  <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                    No momento não existem indicadores
                  </Typography>
                </Box>
                :
                <>
                  <TableComponent />
                </>
          }
        </Box>
      </FixedContainer>

      <Modal
        open={openNewModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <NewPolModal
          onClose={handleClose}
          getList={fillTable}
          table={table}
          lastIpcaFactor={lastIpcaFactor}
        />
      </Modal>

      <Modal
        open={openEditModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <EditModal
          onClose={handleClose}
          agreement={tradeAgreementToEdit}
          setTradeAgreementToEdit={setTradeAgreementToEdit}
          getList={fillTable}
          table={table}
          lastIpca={lastIpcaFactorToEdit}
        />
      </Modal>

      <Modal
        open={openRemoveModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <RemoveModal
          onClose={handleClose}
          agreement={tradeAgreementToEdit}
          getList={fillTable}
          table={table}
        />
      </Modal>
    </>
  );
}

export default FinancialIndicators;